module.exports = __webpack_public_path__ + "static/buddha-statue-fde8f033c5ffb9767b0cb86c4a1ce9ea.jpg";